import { postmortemApiEndpoint } from "../config";
import { fetchToken } from "./fetchTokenService";
import { loginRequest } from "../auth/authConfig";
import { getConsumerKey } from "./maerskApiTokenService";

/**
 * Fetch MTTD / MTTR values for a given incident from the insights API.
 * Returns null on 404 (no record yet) and throws on other errors.
 *
 * Expected response shape:
 *   { mttd: number, mttr: number, ...otherFields }
 */
export async function fetchMttrInsights(incidentId, instance, accounts) {
  const tokenResponse = await fetchToken(instance, loginRequest, accounts);

  const response = await fetch(
    `${postmortemApiEndpoint}/mttr-insights?incidentId=${encodeURIComponent(incidentId)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${tokenResponse.idToken}`,
        "Consumer-Key": getConsumerKey(),
        "Content-Type": "application/json",
      },
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`mttr-insights API error: ${response.status}`);
  }

  return response.json();
}
